export const GasMovementTypes = {
  GET_GAS_MOVEMENTS_REQUESTS: "GET_GAS_MOVEMENTS_REQUESTS",
  NEW_GAS_MOVEMENT: "NEW_GAS_MOVEMENT",
  EDIT_GAS_MOVEMENT: "EDIT_GAS_MOVEMENT",
  SET_CONFIG_FILTERED_GAS_MOVEMENTS: "SET_CONFIG_FILTERED_GAS_MOVEMENTS",
  SET_CONFIG_PAGE_GAS_MOVEMENTS: "SET_CONFIG_PAGE_GAS_MOVEMENTS",
  SET_CONFIG_PAGE_GAS_MOVEMENTS_COUNT: "SET_CONFIG_PAGE_GAS_MOVEMENTS_COUNT",
  SET_CONFIG_SORTED_GAS_MOVEMENTS: "SET_CONFIG_SORTED_GAS_MOVEMENTS",
  
  SET_STATION: "SET_STATION",
  GET_UNITS: "GET_UNITS",
  UPDATE_STATUS: "UPDATE_STATUS",
  DELETE_MOVEMENT: "DELETE_MOVEMENT",
  RESTORE_INITIAL: "RESTORE_INITIAL"
};
